import { getTheme } from '.';

export async function loadThemeFontsAsync() {
    const theme = getTheme();
    await theme?.fontLoader?.();
}
